import React from 'react';
import { Helmet } from 'react-helmet';
import { Dashboard } from 'layouts/Dashboard';
import { Settings } from 'components';

const SettingsPage = () => {
  return (
    <>
      <Helmet>
        <title>Settings</title>
      </Helmet>

      <Dashboard>
        <Settings />
      </Dashboard>
    </>
  );
};

export default SettingsPage;
